export default __webpack_public_path__ + "static/media/visa.1ede6467.svg";